import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import { categories } from '@/mocks/categories';

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex flex-1 flex-col items-center justify-center px-4 py-24 text-center">
        <span className="font-heading text-6xl text-primary-500 md:text-8xl">404</span>
        <h1 className="mt-5 font-heading text-2xl text-foreground-950 md:text-3xl">
          这个瓜好像走丢了
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          页面可能已经下线，或者链接输错了一个字。别急，瓜田里还有很多好玩的等着你。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="rounded-full bg-background-100 px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {cat.name}
            </Link>
          ))}
        </div>
        <Link
          to="/"
          className="mt-8 flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
        >
          <i className="ri-home-5-line" aria-hidden="true"></i>
          回首页继续吃瓜
        </Link>
      </main>
      <SiteFooter />
    </div>
  );
}